import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const FollowListModal = ({ open, onClose, type, userId, token, API, t, isRTL, onOpenProfile }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!open || !userId) return;
    (async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/users/${userId}/${type}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!alive) return;
        setList(Array.isArray(res.data) ? res.data : []);
      } catch {
        if (alive) setList([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [open, userId, type, API, token]);

  if (!open) return null;

  const title = type === 'followers' ? t('followers') : t('following');

  return (
    <div
      data-testid="follow-list-modal"
      dir={isRTL ? 'rtl' : 'ltr'}
      className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-t-2xl sm:rounded-2xl max-h-[80vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <h3 className="text-base font-bold capitalize">{title}</h3>
          <button
            onClick={onClose}
            data-testid="follow-list-close"
            className="p-1.5 rounded-full hover:bg-gray-100 text-gray-500"
            aria-label={t('closeModal')}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="overflow-y-auto">
          {loading ? (
            <div className="py-10 text-center text-gray-500">{t('loading')}</div>
          ) : list.length === 0 ? (
            <div className="py-10 text-center text-gray-500">—</div>
          ) : (
            <ul className="divide-y divide-gray-100">
              {list.map((u) => {
                const uid = u.id || u.user_id || u.follower_id || u.following_id;
                const name = u.name || u.user_name || '?';
                const nickname = u.nickname;
                return (
                  <li key={uid}>
                    <button
                      onClick={() => {
                        onClose();
                        if (onOpenProfile) onOpenProfile(uid);
                      }}
                      data-testid={`follow-list-item-${uid}`}
                      className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 text-start"
                    >
                      <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-purple-400 to-pink-400 flex items-center justify-center text-white font-semibold">
                        {(name || '?').charAt(0).toUpperCase()}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-gray-900 truncate">{name}</p>
                        {nickname && (
                          <p className="text-xs text-gray-500 truncate">@{nickname}</p>
                        )}
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowListModal;
